module.exports = __webpack_public_path__ + "static/media/23_B.a8d558aa.png";